import React from 'react';
import { Button, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import moment from 'moment';
import SubtleBadge from 'components/common/SubtleBadge';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import Flex from 'components/common/Flex';

const CustomerOrderLog = ({ customerOrderList }) => {
  // console.log(customerOrderList);
  const columns = [
    {
      accessorKey: 'id',
      header: 'Order',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { id, additionalFields } = original;
        return (
          <div>
            <Flex>
              <h5 className="mb-0 fs-10 text-primary">#{id}</h5>
              <h5 className="mb-0 fs-10 text-secondary mx-1"> by </h5>
              <h5 className="mb-0 fs-10">
                {additionalFields[0]?.customerName}
              </h5>
            </Flex>
            <a href={`mailto:${additionalFields[0]?.customerDetails?.email}`}>
              {additionalFields[0]?.customerDetails?.email}
            </a>
          </div>
        );
      }
    },
    {
      accessorKey: 'licenseTypes',
      header: 'LicenseTypes',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { additionalFields } = original;
        return (
          <div>
            {additionalFields[0]?.licenseTypes?.map((item, index) => {
              return (
                <h5 key={index} className="mb-0 fs-10">
                  {item}
                </h5>
              );
            })}
          </div>
        );
      }
    },
    {
      accessorKey: 'start',
      header: 'Date (Start & End)',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { additionalFields } = original;
        return (
          <div>
            <h5 className="mb-0 fs-10">
              {moment(additionalFields[0]?.startTime).format(
                'MMMM DD YYYY hh:mm a'
              )}
            </h5>
            <h5 className="mb-0 fs-10 mt-1">
              {moment(additionalFields[0]?.endTime).format(
                'MMMM DD YYYY hh:mm a'
              )}
            </h5>
          </div>
        );
      }
    },
    {
      accessorKey: 'notes',
      header: 'Notes',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { additionalFields } = original;
        return <h5 className="mb-0 fs-10">{additionalFields[0]?.notes}</h5>;
      }
    },
    {
      accessorKey: 'status',
      header: 'Status',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { additionalFields } = original;
        return (
          <SubtleBadge
            pill
            bg={
              additionalFields[0]?.status === 'Canceled'
                ? 'danger'
                : additionalFields[0]?.status === 'Processed'
                ? 'success'
                : additionalFields[0]?.status === 'Unfulfilled'
                ? 'secondary'
                : 'primary'
            }
          >
            {additionalFields[0]?.status}
          </SubtleBadge>
        );
      }
    },
    {
      accessorKey: 'createdAt',
      header: 'Created',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { createdAt } = original;
        return (
          <h5 className="mb-0 fs-10">
            {moment(createdAt).format('MMMM DD YYYY hh:mm a')}
          </h5>
        );
      }
    },
    {
      accessorKey: '',
      header: 'Action',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { additionalFields, id } = original;
        return (
          <>
            {additionalFields[0]?.status === 'Pending' ? (
              <Link to={paths.nursd_order_form(id)}>
                <Button size="sm">Create</Button>
              </Link>
            ) : null}
          </>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: customerOrderList,
    columns,
    // selection: true,
    sortable: true,
    pagination: true,
    perPage: 10
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Card className="mb-3">
          <Card.Header>
            <h5>Order List</h5>
          </Card.Header>
          <Card.Body className="p-0">
            <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs-10 mb-0 overflow-hidden'
              }}
            />
          </Card.Body>
          <Card.Footer>
            <div className="mt-3">
              <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
            </div>
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
    </>
  );
};

CustomerOrderLog.propTypes = {
  customerOrderList: PropTypes.any
};

export default CustomerOrderLog;
